<template>    
    <div class="card course" :class="{
        'featured': (highlightFeatured && session.is_featured),
        'past': isPast
    }">

        <div class="card-body">
            <a :href="session.uri">
                <img class="card-img-top-virtuoso h-auto" :src="session.imageUris ? session.imageUris.cardThumb.url : ''" :alt="session.name" loading="lazy" width="320" height="180">
            </a>

            <template v-if="session.teachers">                
                <template v-if="session.teachers.length > 0">
                    <div class="teacher-list grey-subtitle">{{ session.teachers[0].name }}</div>
                </template>
            </template>

            <a :href="session.uri">
                <h2 class="card-title">{{ session.name }}</h2>
            </a>

            <p class="card-text">
                {{ session.description_short }}
            </p>

            <hr>

            <p class="card-text" v-if="! hideDates">
                Date: {{ session.enrolByDateFormatted }}<br>
                Time: {{ session.startTimeFormatted }}–{{ session.endTimeFormatted }} {{ session.timezoneAbbr }}
            </p>

            <div class="row no-gutters btn-area">
                <div class="col">
                    <a :href="session.uri" class="btn btn-primary btn-main">Find Out More</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: {
                type: Number,
                default: null
            },
            sessionData: {
                type: Object,
                default: null
            },
            highlightFeatured: {
                type: Boolean,
                default: true
            },
            isPast: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                session: {},
                hideDates: false,
            }
        },

        mounted() {
            if(this.sessionData) {
                this.session = this.sessionData;
            } else {
                this.getArtistSession();
            }

            if(this.session.id == 77) {
                this.hideDates = true;
            }
        },

        methods: {
            getArtistSession: function() {
                axios.get('/api/artist-sessions/' + this.id)
                    .then((response) => {
                        this.session = response.data;
                    });
            }
        }
    }
</script>
